import { Component, Prop, Vue } from "vue-property-decorator";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";

@Component
export default class TalkToMeJrOutro extends Vue {
  render(h: CreateElement) {
    return (
      <Card>
        <div slot="mainContent">
          You’re finished! Thank you for doing BalanceAI. We Hope you Enjoyed
        </div>
        <div slot="actions">
          <v-btn color="primary" to="/home">
            Next
          </v-btn>
        </div>
      </Card>
    );
  }
}

const component = TalkToMeJrOutro;
